import React, { useContext } from "react";
import { createPortal } from "react-dom";
import BaseDialog from "@/shared/components/dialog/base-dialog";
import { ErrorDialogContext, extractErrorInfo } from "@/shared/context/error-context";
import { BaseRoundButton } from "@/shared/components/button/base-round-button";

/** エラーダイアログ用の z-index（どのモーダルよりも上に表示するため最高値を設定） */
const ERROR_DIALOG_Z_INDEX = 9999;

export const ErrorDialog = () => {
  const { error, setError } = useContext(ErrorDialogContext);

  // エラーがない場合は何もレンダリングしない
  if (typeof error === "undefined") {
    return null;
  }

  const { title, message } = extractErrorInfo(error);
  // messageに\nが入っている場合はそこで改行して表示
  const formattedMessage: React.ReactNode =
  typeof message === "string"
    ? message.split("\n").map((line, index) => (
        <React.Fragment key={index}>
          {line}
          <br />
        </React.Fragment>
      ))
    : message;

  // Portal を使って document.body に直接レンダリングすることで、
  // 他のモーダルや要素に影響を与えずに最前面に表示
  return createPortal(
    <BaseDialog
      isShow={true}
      title={<h1 className="select-dialog__header">{title}</h1>}
      rightButton={
        <BaseRoundButton
          className="select-dialog__button"
          buttonText="閉じる"
          onClick={() => setError(undefined)}
        />
      }
      outAreaOnTap={() => setError(undefined)}
      zIndex={ERROR_DIALOG_Z_INDEX}
      overlayId="errorDialogOverlay"
    >
      <div className="dialog">
        <p className="dialog__error_message">{formattedMessage}</p>
      </div>
    </BaseDialog>,
    document.body
  );
};
